module.exports = __webpack_public_path__ + "static/STG20_Desktop_2880_Module2_YellowSpritz-6658e0b6a39488d76ff0487e8cf91cc9.jpg";